import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseDateRangeSelectorComponent } from '../base-date-range-selector/base-date-range-selector.component';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';

@Component({
  selector: 'app-daily-date-range-selector',
  templateUrl: './daily-date-range-selector.component.html',
  styleUrls: ['./daily-date-range-selector.component.css']
})
export class DailyDateRangeSelectorComponent extends BaseDateRangeSelectorComponent implements OnInit {

  beginDatepicker: MatDatepicker<Date>;
  endDatepicker: MatDatepicker<Date>;

  //Shamelessly borrowed from Stackoverflow
  protected firstDayInPreviousMonth(yourDate) {
    return new Date(yourDate.getFullYear(), yourDate.getMonth() - 1, 1);
  }

  protected lastDayInThatMonth(yourDate) {
    //Ugh, fine.  We'll figure this out the hard way.  The simple javascript-ey solution to figure out the last day of the month would fail in January, where it would overflow into the subsequent year.

    let nextMonth = yourDate.getMonth() + 1;
    let year = yourDate.getFullYear();

    let finalDate;
    

    if(nextMonth > 11) {
      let year = yourDate.getFullYear();
      finalDate = new Date(year, nextMonth, 0);      
    }
    else {
      //For most cases, this works fine.
      finalDate = new Date(yourDate.getFullYear(), nextMonth, 0);
    }

    return finalDate;
  }

  constructor(
    formBuilder: FormBuilder
  ) {
    super(formBuilder);

    //What we're doing here is setting the beginning and ending dates to the first and last days of the previous month, which are the most likely dates that the user wants.
    /*this.beginDate = new Date();
    this.beginDate.setMonth(this.beginDate.getMonth() - 1)
    this.beginDate.setDate(1);*/

    let today = new Date();

    this.beginDate = this.firstDayInPreviousMonth(today);

    this.endDate = this.lastDayInThatMonth(this.beginDate);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  
  handleEndDateChange(event) {
    var _this = this;
    setTimeout(function () {
      _this.dateBoundsSelectionForm.get("EndDate").setValue(event);
    });
    
  }

  handleBeginDateChange(event) {

    var _this = this;

    setTimeout(function () {
      _this.dateBoundsSelectionForm.get("BeginDate").setValue(event);
    });
    
  }
}
